import styles from "../add.module.css";
import axios from "axios";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { usePlacesWidget } from "react-google-autocomplete";
import { useState, useEffect } from "react";
import MapComponent from "../../../../fontend/components/Map";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { authCustomerData, authData } from "../../../../admin/components/GetAuth";
import { Plus, Trash2 } from "react-feather";

function Step3({ saveStep3Data, backToTab, bookingData, selectCountry }) {
  const auth = authData();
  const authCustomer = authCustomerData();
  const [userAddressList, setUserAddressList] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 5.614818, lng: -0.205874 });
  const [isMarker, setIsMarker] = useState(false);
  const [zoom, setZoom] = useState(12);
  const [defaultCustomer, setDefaultCustomer] = useState("");

  const { register, handleSubmit, control, formState: { errors }, clearErrors, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      customer_id: "",
      name: "",
      email: "",
      phone: "",
      address: "",
      alt_phones: [],
    },
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "alt_phones"
  });

  const { ref: placeRef1 } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("address", place.formatted_address);
      setValue("latitude", place.geometry.location.lat());
      setValue("longitude", place.geometry.location.lng());

      setMapCenter({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
      setIsMarker(true);
      setZoom(18);
    },
    options: {
      types: ["geocode"],
      componentRestrictions: { country: selectCountry }
    },
  });

  useEffect(() => {
    if (authCustomer?.id) {
      axios.get(process.env.REACT_APP_API_URL + "v1/customer/adresses/recipient", {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          setUserAddressList([{ value: -1, name: "New record" }].concat(response.data.data));

          if (response.data.data.length > 0) {
            setValue("customer_id", response.data.data[0].value);
            setDefaultCustomer(response.data.data[0].value);
          } else {
            setValue("customer_id", -1);
            setDefaultCustomer(-1);
          }
        }
      });
      // FIX: this fetch is for the recipient list, so it should only re-run based on
      // recipientData, not pickUpData (which belongs to Step2 / the sender).
    }
  }, [auth?.api_token, authCustomer?.id, bookingData?.recipientData, setValue]);

  useEffect(() => {
    // FIX: these fields were being populated from bookingData?.pickUpData, which
    // silently overwrote the recipient form with the sender's saved data. This
    // step is for the recipient, so it must read from bookingData?.recipientData.
    setValue("customer_id", bookingData?.recipientData?.customer_id);
    setValue("name", bookingData?.recipientData?.name);
    setValue("email", bookingData?.recipientData?.email);
    setValue("phone", bookingData?.recipientData?.phone);
    setValue("address", bookingData?.recipientData?.address);

    if (bookingData?.recipientData?.alt_phones?.length) {
      replace(bookingData?.recipientData?.alt_phones);
    }

    if (bookingData?.recipientData?.latitude && bookingData?.recipientData?.longitude) {
      setValue("latitude", bookingData?.recipientData?.latitude);
      setValue("longitude", bookingData?.recipientData?.longitude);
      setMapCenter({ lat: parseFloat(bookingData?.recipientData?.latitude), lng: parseFloat(bookingData?.recipientData?.longitude) });
      setIsMarker(true);
      setZoom(18);
    }
  }, [bookingData, setValue, replace]);

  useEffect(() => {
    if (defaultCustomer === -1) {
      setValue(`name`, "");
      setValue(`email`, "");
      setValue(`phone`, "");
      setValue(`address`, "");
      replace([]);
      setIsMarker(false);
      setZoom(18);
    } else {
      let addressObj = userAddressList.filter((i) => i?.value === defaultCustomer);
      if (addressObj.length > 0) {
        addressObj = addressObj[0];

        setValue("name", addressObj?.name);
        setValue("email", addressObj?.email);
        setValue("phone", addressObj?.phone);
        setValue("address", addressObj?.address);

        replace(addressObj?.alt_phones?.length ? addressObj?.alt_phones : []);

        if (addressObj?.latitude && addressObj?.longitude) {
          setValue(`latitude`, parseFloat(addressObj?.latitude));
          setValue(`longitude`, parseFloat(addressObj?.longitude));
          setMapCenter({ lat: parseFloat(addressObj?.latitude), lng: parseFloat(addressObj?.longitude) });
          setIsMarker(true);
          setZoom(18);
        }

        clearErrors();
      }
    }
  }, [defaultCustomer, userAddressList, clearErrors, setValue, replace]);

  const onSubmit = (data) => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
    saveStep3Data(data);
  }

  return (<>
    <div className={`${styles.StepOneForm}`}>
      <p className={styles.SectionLabel}>Recipient / delivery details</p>
      <form id="step2-form" onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.StepOneFormRow}`}>
          <div className={`${styles.StepOneFormBig}`}>
            <div className={styles.FormFullGroup}>
              <FormControl fullWidth>
                <InputLabel>Select or add record*</InputLabel>
                <Controller
                  control={control}
                  {...register("customer_id")}
                  render={({ field }) => (<Select
                    label="Select or add record*"
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                      setDefaultCustomer(e.target.value);
                    }}
                  >
                    {userAddressList?.map((val) => {
                      return (<MenuItem key={val?.value} value={val?.value}>{val?.name}, {val?.address}</MenuItem>);
                    })}
                  </Select>)}
                />
              </FormControl>
            </div>

            <div className={styles.FormFullGroup}>
              <Controller
                control={control}
                {...register("name", { required: "This field is Required" })}
                render={({ field }) => (<TextField {...field} label="Name*" variant="outlined" />)}
              />
              {errors.name && (<span className={styles.ErrorM}>{errors?.name?.message}</span>)}
            </div>

            <div className={styles.FormFullGroup}>
              <Controller
                control={control}
                {...register("phone", { required: "This field is Required" })}
                render={({ field }) => (<TextField {...field} label="Phone*" variant="outlined" />)}
              />
              {errors.phone && (<span className={styles.ErrorM}>{errors.phone.message}</span>)}
            </div>

            {fields.map((item, index) => {
              return (<div className={styles.FormFullGroup} key={item.id}>
                <div className={`${styles.AltConSec}`} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Controller
                    control={control}
                    {...register(`alt_phones[${index}].value`, { required: "This field is Required" })}
                    render={({ field }) => (<TextField {...field} label="Alt Phone*" variant="outlined" />)}
                  />
                  <button type='button' onClick={() => remove(index)} className={`${styles.ConNoBU}`}><Trash2 /></button>
                </div>
                {(errors?.alt_phones?.length > 0 && errors?.alt_phones[index]?.value) && <p className={styles.ErrorM}>{errors?.alt_phones[index]?.value?.message}</p>}
              </div>)
            })}
            <button type='button' onClick={() => { append({ value: '' }); }} className={`${styles.AddAltConNO}`}><Plus /> Add alt phone</button>

            <div className={styles.FormFullGroup}>
              <Controller
                control={control}
                {...register("email")}
                render={({ field }) => (<TextField {...field} label="Email" variant="outlined" />)}
              />
            </div>
          </div>

          <div className={`${styles.StepOneFormSmall2} ${styles.StepOneFormSmall254}`}>
            <div className={styles.FormFullGroup2}>
              <Controller
                control={control}
                {...register("address", { required: "This field is Required" })}
                render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" inputRef={placeRef1} placeholder="" />)}
              />
              {errors?.address && (<p className={styles.ErrorM}>{errors?.address?.message}</p>)}
            </div>
            <div>
              <MapComponent center={mapCenter} zoom={zoom} isMarker={isMarker} />
            </div>
          </div>

          <div className={`${styles.StepBUSec}`}>
            <button type="button" onClick={backToTab} className={`${styles.Previous}`}>Back</button>
            <button type="submit" className={`${styles.Next}`}>Next</button>
          </div>
        </div>
      </form>
    </div>
  </>);
}

export default Step3;